/**
 * クルンサイアムなどのレストラン系ページに関する処理
 */

export default class SingleRestaurant {
  constructor(_parm) {
    this.pageParent = document.querySelector('.p-single-restaurant') || false;
    if (!this.pageParent) return;
  }

  /**
   * SPハンバーガーメニュー初期化
   */
  spMenuInit() {
    const toggleButton = document.querySelector('#js-hamburger-menu');
    const drawerMenu = document.querySelector('#js-sp-drawer-menu');
    const links = document.querySelectorAll('#js-sp-drawer-menu-list a');
    const openAttr = 'data-open';
    const toggleShow = isShow => {
      toggleButton.setAttribute(openAttr, isShow);
      drawerMenu.setAttribute(openAttr, isShow);
    }
    // ハンバーガーメニュークリック
    toggleButton.addEventListener('click', (e) => {
      if (toggleButton.getAttribute(openAttr) === 'true') {
        toggleShow(false);
      } else {
        toggleShow(true);
      }
    });
    // リンクをクリックしたらメニュー閉じる
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        toggleShow(false);
      });
    });
  }

  /**
   * ヘッダーの言語ボタンの初期化
   */
  headerLangInit() {
    const langShowButton = document.querySelector('#js-restaurant-header-lang-button');
    const langModal = document.querySelector('#js-restaurant-header-lang-target');
    let isShow = false;
    // クリックしたら言語切替プルダウンが表示されるように
    langShowButton.addEventListener('click', (e) => {
      langModal.style.display = 'block';
      isShow = true;
    });
    // 言語ボタン以外をクリックしたら、言語切替プルダウンを非表示に
    document.addEventListener('click', function (event) {
      if (!langShowButton.contains(event.target)) {
        if (isShow) {
          langModal.style.display = 'none';
          isShow = false;
        }
      }
    });
    // 選択中の言語を最上部に持ってくる
    (() => {
      // 選択中の言語を取得
      const currentLanguage = document.querySelector('.list-view li.current');
      // 日本語のliを取得
      const jaLanguage = langModal.querySelector('ul li.ja');
      // 日本語選択中であればなにもしない
      if (currentLanguage.classList.contains('ja')) return;
      // 英語選択中の場合
      if (currentLanguage.classList.contains('en')) {
        jaLanguage.classList.add('enSelected');
      }
      // タイ語選択中の場合
      if (currentLanguage.classList.contains('th')) {
        jaLanguage.classList.add('thSelected');
      }
    })();
  }

  /**
   * フッターの各種リンクに、target="_blank"を追加
   */
  footerLinkAddTargetBlankInit() {
    const links = document.querySelectorAll('#js-footer a');
    // レストランページのURLに合致する場合のみ実行
    links.forEach((link) => {
      // aタグに、target="_blank"を付与
      link.setAttribute('target', '_blank');
    });
  }

  init() {
    if (!this.pageParent) return;
    this.spMenuInit();
    this.headerLangInit();
    this.footerLinkAddTargetBlankInit();
  }
}
